import moment from "moment";
import {meterTypesDictionary} from "../Pages/WaterSystems/meterTypeDictionary";
import {ACTUATOR, ALGO_PARAMETERS, COMMUNICATION_INTERFACE, COMPATIBLE_CONTROL_UNIT_TYPES, MANUFACTURER, REGION, RETURN_METER, RETURN_VALVE, SUPPLY_METER, SUPPLY_VALVE, VALVE} from "../Pages/HardwareCatalog/Constants/constants"
import {ADMIN_USER, HARDWARE_CATALOG_ADMIN, INDEX_NOT_FOUND, METER_UUIDS, METERS_LOW_CASE, REFERENCE_DIAMETER_ID, VALVE_UUIDS, VALVES_LOW_CASE} from "../Constants/constants";
import {Expiring} from "../Axios/expiring";
import {ACCESS_TOKEN_COOKIE, TOKEN_TYPE_COOKIE} from "../Axios/axiosConfig";
import Cookies from 'js-cookie';
import {SET_EDIT_MODE, SET_IS_PREPARING_EXCEL_DATA, SET_REMOTE_TABLE_LOADING} from "../Store/ActionTypes/General/actionTypes";
import {useState} from "react";
import {Box, MenuItem, TextField, Typography} from "@mui/material";
import Checkbox from '@mui/material/Checkbox';


export const DateFormatter = date => {
    return date ? moment(date).format('lll') : "";
}

export const PulseToLiter = (valveType = REFERENCE_DIAMETER_ID) => {
    const pipeConfig = meterTypesDictionary[valveType];
    const defaultPipeConfig = meterTypesDictionary[REFERENCE_DIAMETER_ID];
    return (pipeConfig?.pulseRatio / defaultPipeConfig?.pulseRatio);
}

export const buildSystemCycleStateString = (selectedSystemStatesValues) => {
    let systemStateString = '';
    selectedSystemStatesValues.forEach(systemState => {
        systemStateString += "\"" + systemState.value + "\"" + ', ';
    })
    systemStateString = systemStateString.slice(0, systemStateString.length - 2);
    return systemStateString;
}

export function getCurrentAuthToken() {
    const accessToken = Expiring.fromCookie(ACCESS_TOKEN_COOKIE);
    if (!accessToken || accessToken.expired) {
        return null;
    }
    return `${Cookies.get(TOKEN_TYPE_COOKIE)} ${accessToken.value}`;
}

export const setEditMode = (dispatch, mode) => {
    dispatch({
        type: SET_EDIT_MODE, payload: mode
    });
}

export const setRemoteTableLoading = (dispatch, isLoading) => {
    dispatch({
        type: SET_REMOTE_TABLE_LOADING, payload: isLoading
    });
}

export const setIsPreparingExcelData = (dispatch, isLoading) => {
    dispatch({
        type: SET_IS_PREPARING_EXCEL_DATA, payload: isLoading
    });
}

export const increaseDateByOneDay = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return date.toISOString();

};

export const createFiltersQueryString = (filters) => {
    let adjustedFiltersObj = JSON.parse(JSON.stringify(filters));
    let filterQueryString = ';';
    for (let key in filters) {
        if (typeof filters[key] === 'object' && filters[key].hasOwnProperty('filterType')) {
            if (filters[key].filterType === 'DATE' && filters[key].comparator === 'LIKE' && filters[key].filterVal.comparator !== '' && adjustedFiltersObj[key].filterVal.date) {
                if (filters[key].filterVal.comparator === '>') {
                    adjustedFiltersObj[key].filterVal.date = increaseDateByOneDay(adjustedFiltersObj[key].filterVal.date);
                }
                if (filters[key].filterVal.comparator === '<=') {
                    adjustedFiltersObj[key].filterVal.date = increaseDateByOneDay(adjustedFiltersObj[key].filterVal.date);
                }
                if (filters[key].filterVal.comparator === '=') {
                    adjustedFiltersObj[key].comparator = '==';
                } else {
                    adjustedFiltersObj[key].comparator = filters[key].filterVal.comparator;
                }
                let dateString = adjustedFiltersObj[key].filterVal.date;

                if (dateString.endsWith('z') || dateString.endsWith('Z')) {
                    dateString = dateString.slice(0, -1);
                }
                filterQueryString += `${key}${adjustedFiltersObj[key].comparator}\'${dateString}\';`;
            }
            if (filters[key].filterType === 'NUMBER' && filters[key].comparator === 'LIKE' && filters[key].filterVal.comparator !== '' && adjustedFiltersObj[key].filterVal.number) {
                if (filters[key].filterVal.comparator === '=') {
                    adjustedFiltersObj[key].comparator = '==';
                } else {
                    adjustedFiltersObj[key].comparator = filters[key].filterVal.comparator;
                }
                filterQueryString += `${key}${adjustedFiltersObj[key].comparator}${adjustedFiltersObj[key].filterVal.number};`;
            }
            if (filters[key].filterType === 'SELECT' && filters[key].comparator === '=') {
                adjustedFiltersObj[key].comparator = '==';
                filterQueryString += `${key}${adjustedFiltersObj[key].comparator}\'${adjustedFiltersObj[key].filterVal}\';`;
            }
            if (filters[key].filterType === 'TEXT' && filters[key].comparator === 'LIKE') {
                adjustedFiltersObj[key].comparator = 'ilike';
                filterQueryString += `${key}=${adjustedFiltersObj[key].comparator}=\'${adjustedFiltersObj[key].filterVal}\';`;
            }
            if (filters[key].filterType === 'MULTISELECT' && filters[key].comparator === 'LIKE') {
                adjustedFiltersObj[key].comparator = 'in';
                const items = adjustedFiltersObj[key].filterVal.map(it => `\'${it}\'`).join(',');
                filterQueryString += `${key}=${adjustedFiltersObj[key].comparator}=(${items});`;
            }
        }
    }
    if (filterQueryString.endsWith(';')) {
        filterQueryString = filterQueryString.slice(0, -1);
    }
    return filterQueryString;
}


export const findLabelByValue = (filterOptions, searchValue) => {
    const foundOption = filterOptions.find(option => {
        return option.value.toString() === searchValue?.toString();
    })
    return foundOption ? foundOption.label : null;
}

export const meterTypeFilterOptions = () => {
    let options = [];

    for (const meterTypeId in meterTypesDictionary) {
        const meterTypesDictionaryElement = meterTypesDictionary[meterTypeId];
        let value = `${meterTypesDictionaryElement.displayName} (${meterTypesDictionaryElement.meterType})`
        options.push({value: meterTypeId, label: value});
    }
    return options;
}

export const snakeCaseToNormalString = (input) => {
    if (!input || typeof input !== "string") {
        return "";
    }
    const words = input.split('_');
    const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    const remainingWords = words.slice(1).map(word => word.toLowerCase());
    return [firstWord, ...remainingWords].join(' ');
}

export const capitalizeWords = (sentence) => {
    if (!sentence || typeof sentence !== "string") {
        return "";
    }
    const words = sentence.split(" ");
    const capitalizedWords = words.map((word) => {
        if (word.length > 0) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        } else {
            return word;
        }
    });
    return capitalizedWords.join(" ");
}

export const updateValveOrMeterArray = (valveOrMeterArray, itemUuidToAddOrRemove, shouldAdd) => {
    let updatedValveOrMeterArray = valveOrMeterArray ? [...valveOrMeterArray] : [];
    const index = updatedValveOrMeterArray.indexOf(itemUuidToAddOrRemove);
    if (shouldAdd && index === INDEX_NOT_FOUND) {
        updatedValveOrMeterArray.push(itemUuidToAddOrRemove);
    } else if (!shouldAdd && index !== INDEX_NOT_FOUND) {
        updatedValveOrMeterArray.splice(index, 1);
    }
    return updatedValveOrMeterArray;
};

export const updateVmaItems = (selectedVmaUuid, itemUuid, previousValue, itemType, stateObj) => {
    return stateObj.state.vmaListArr.map((vmaListItem) => {
        const items = vmaListItem[itemType];

        if (vmaListItem.uuid === selectedVmaUuid) {
            return {...vmaListItem, [itemType]: updateValveOrMeterArray(items, itemUuid, true)};
        } else if (vmaListItem.uuid === previousValue.value) {
            if (selectedVmaUuid === previousValue.value) {
                console.warn(`Warning: Attempting to add and remove a ${itemType} to/from the same VMA.`);
                return vmaListItem;
            }
            return {...vmaListItem, [itemType]: updateValveOrMeterArray(items, itemUuid, false)};
        } else {
            return vmaListItem;
        }
    })
};

export const updateControlUnitDetails = (updatedVmaList, controlUnitDetails, vmaData, setControlUnitDetails, itemType) => {
    let currentVmaState;
    let uuidType;
    let otherUuidType;
    let otherItemType;
    if (itemType === METERS_LOW_CASE) {
        otherItemType = VALVES_LOW_CASE;
        uuidType = METER_UUIDS;
        otherUuidType = VALVE_UUIDS;
    } else {
        otherItemType = METERS_LOW_CASE;
        uuidType = VALVE_UUIDS;
        otherUuidType = METER_UUIDS;
    }

    let newControlUnitDetails = controlUnitDetails;
    newControlUnitDetails.vmas = vmaData.map(vma => {
        currentVmaState = updatedVmaList.filter((obj) => obj.uuid === vma.uuid);
        return {
            ...vma,
            [uuidType]: currentVmaState[0][itemType],
            [otherUuidType]: currentVmaState[0][otherItemType]
        };
    });
    setControlUnitDetails(newControlUnitDetails);
}

export const getVmaLabelByUuid = (vmaUuid, stateObj) => {
    let label;
    stateObj.state?.dropdownOptionsArr?.filter(option => {
        if (option.value === vmaUuid) {
            label = option.label;
        }
    })
    return label;
}

export const validateRequired = (value) => {
    const stringValue = value?.toString();
    return stringValue ? stringValue.length > 0 : false;
}

export const renderNonWarpingHeader = (header) => {
    return <span style={{whiteSpace: 'nowrap'}}>{header}</span>
}

export const SelectFieldCellEditor = (row, column, value, options, required = true, setValidationErrors, validationErrors) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
        const option = options.find(option => option.label === event.target.value)?.value;
        const optionId = option ? {id: option.id} : null;
        delete row._valuesCache[column.id];
        row._valuesCache[column.id] = optionId;
    };

    return <TextField select
                      fullWidth
                      label={column.columnDef.header}
                      variant="standard"
                      value={selectedValue}
                      onChange={handleChange}
                      error={!!validationErrors?.[column.id]}
                      helperText={validationErrors?.[column.id]}
                      required={required}
                      onFocus={() =>
                          setValidationErrors({
                              ...validationErrors,
                              [column.id]: undefined,
                          })}
    >
        {options?.map(option =>
            <MenuItem key={option.value} value={option.label}>
                {option.label}
            </MenuItem>)}
    </TextField>;
}

export const ArrayTextFieldEditor = (row, column, value, required = true, setValidationErrors, validationErrors) => {
    const [inputValue, setInputValue] = useState(value ? value?.join(', ') : []);

    const handleChange = (event) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        row._valuesCache[column.id] = newValue.split(',').map(item => item.trim());
    };

    return (
        <TextField
            fullWidth
            label={column.columnDef.header}
            variant="standard"
            value={inputValue}
            onChange={handleChange}
            error={!!validationErrors?.[column.id]}
            helperText={validationErrors?.[column.id]}
            onFocus={() => setValidationErrors({
                ...validationErrors,
                [column.id]: undefined,
            })}
        />
    );
};


export const MultiSelectTextFieldCellEditor = (row, column, value, options, required = true, setValidationErrors, validationErrors) => {
    const [selectedValues, setSelectedValues] = useState(value || []);

    const handleChange = (event) => {
        const currentSelectedLabels = event.target.value;
        const currentSelectedValues = currentSelectedLabels.map(
            selectedLabel => options.find(option => option.label === selectedLabel)?.value
        );
        setSelectedValues(currentSelectedValues);
        row._valuesCache[column.id] = currentSelectedValues;
    };

    return (
        <TextField
            select
            fullWidth
            label={column.columnDef.header}
            variant="standard"
            value={selectedValues.map(value => options.find(option => option.value === value)?.label || '')}
            onChange={handleChange}
            error={!!validationErrors?.[column.id]}
            helperText={validationErrors?.[column.id]}
            required={required}
            SelectProps={{
                multiple: true,
                renderValue: (selected) => selected.join(', '),
            }}
            onFocus={() =>
                setValidationErrors({
                    ...validationErrors,
                    [column.id]: undefined,
                })}
        >
            {options.map(option => (
                <MenuItem key={option.value} value={option.label}>
                    <Checkbox checked={selectedValues.includes(option.value)}/>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export const findEnumLabelByValue = (value, enums) => {
    for (let category in enums) {
        for (let label in enums[category]) {
            if (enums[category][label] === value?.toString()) {
                return label;
            }
        }
    }
    return value;
}

export const renderColumnValue = (column, viewRow, enums) => {
    let value;
    switch (column.id) {
        case COMMUNICATION_INTERFACE:
            value = viewRow.renderValue(column.id)?.type
            break;
        case ACTUATOR:
        case VALVE:
        case MANUFACTURER:
        case ALGO_PARAMETERS:
        case REGION:
        case SUPPLY_METER:
        case SUPPLY_VALVE:
        case RETURN_METER:
        case RETURN_VALVE:
            value = viewRow.renderValue(column.id)?.name
            break;
        case COMPATIBLE_CONTROL_UNIT_TYPES:
            value = viewRow.renderValue(column.id)
            return value.map((controlUnit) => ' ' + findEnumLabelByValue(controlUnit, enums));
        default:
            value = viewRow.renderValue(column.id)
    }
    return findEnumLabelByValue(value, enums);

}

export async function validateEntity(values, schema) {
    const validationErrors = {};
    try {
        await schema.validate(values, {abortEarly: false});
    } catch (error) {
        error.inner.forEach(err => {
            if (!validationErrors[err.path]) {
                validationErrors[err.path] = err.message;
            }
        });
    }
    return validationErrors;
}

export const createLabelWithLineBreaks = (label) => {
    const words = label.split(' ');
    return (
        <Box>
            {words.map((word, index) => (
                <Typography key={index} component="div">
                    {word}
                </Typography>
            ))}
        </Box>
    );
};

export const hasAdminRoles = (userRole) => {
    return userRole === ADMIN_USER || userRole === HARDWARE_CATALOG_ADMIN;
};
